 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		24: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		24: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"framework","2":"2a42ed5b309b831996b49f08982ab7a4a24cae99","3":"0dd23f8cf9c6f4caba27e235780dc69f3665b42c","4":"e47fa9d5621b4e95aef8c07db5248df460519f91","5":"518cf1bce0dd04dc8c82e7e6b9851ff0d0b411dd","6":"1cfffe9f2e2abb3f8b3fd86840a4610f09ce1a32","7":"6944b5aa0dc5a4b0d337022ab4f44b8d0707a7bf","8":"ba2f737c89566affd54764cb6f4f4f24a7646d17","9":"d2918d33d883d725aee5f3ab6866aaa16243464b","10":"12552576a31d6d3d68f0b52e02739bbcfb8d4e73","11":"2365c79a59cabec54cd953fa05099f6130610e74","12":"2e6fd670878c7735087648f90002cdf1da0d4eaa","13":"7409aab60587d71ec7ac8ecdba1e280c541d0e28","14":"76223ff1009fe48bc60fbd7f75ff3c1d7a8c3748","15":"801a6084","16":"86889760b04c8d71da5a8b65d053f0fff4028907","17":"9f47a220e662f3d5ed876574306c3299ef29bc5f","18":"a2adb2a871cb4ae6843dd1f6e70c9ec95cc7d9c2","19":"styles","20":"5c968fe111ae3542c1f4673d3d051a3122a88ccc","21":"abf5ef3964d590ff84d589378b6f16e7ade0a4e3","22":"bcc0eb07330911ac31b0cf0fafa591ac97603503","23":"component---src-pages-account-subscriptions-flavours-js","29":"component---src-pages-404-js","30":"component---src-pages-account-email-verification-js","31":"component---src-pages-account-index-js","32":"component---src-pages-account-orders-js","33":"component---src-pages-account-rewards-js","34":"component---src-pages-account-savings-js","35":"component---src-pages-account-subscriptions-details-js","36":"component---src-pages-account-subscriptions-draft-js","37":"component---src-pages-account-subscriptions-index-js","38":"component---src-pages-bc-ban-js","39":"component---src-pages-bc-js","40":"component---src-pages-benefits-js","41":"component---src-pages-boost-plan-js","42":"component---src-pages-buy-online-epod-starter-bundle-js","43":"component---src-pages-buy-online-multipack-3-js","44":"component---src-pages-buy-online-multipack-5-js","45":"component---src-pages-buy-online-vuse-pods-js","46":"component---src-pages-buy-online-vype-epen-3-cartridges-js","47":"component---src-pages-buy-online-vype-epod-accessories-epod-charger-js","48":"component---src-pages-buy-online-vype-epod-accessories-js","49":"component---src-pages-buy-online-vype-epod-accessories-the-pouch-js","50":"component---src-pages-buy-online-vype-epod-skins-js","51":"component---src-pages-buy-online-vype-epod-vpro-cartridges-js","52":"component---src-pages-cart-js","53":"component---src-pages-challenge-js","54":"component---src-pages-checkout-js","55":"component---src-pages-clear-js","56":"component---src-pages-create-password-js","57":"component---src-pages-flagship-store-toronto-js","58":"component---src-pages-forgot-password-js","59":"component---src-pages-index-js","60":"component---src-pages-know-your-vuse-js","61":"component---src-pages-ontario-ban-js","62":"component---src-pages-ontario-js","63":"component---src-pages-order-confirmation-js","64":"component---src-pages-pos-rating-js","65":"component---src-pages-qc-js","66":"component---src-pages-queued-order-confirmation-js","67":"component---src-pages-referral-js","68":"component---src-pages-reset-password-js","69":"component---src-pages-soft-verify-js","70":"component---src-pages-subscribe-js","71":"component---src-pages-upgrade-to-epod-js","72":"component---src-pages-vape-stores-js","73":"component---src-pages-vuse-plus-vape-deals-js","74":"component---src-pages-vype-epod-starter-kit-js","75":"component---src-pages-vype-is-becoming-vuse-js","76":"component---src-templates-buy-js","77":"component---src-templates-cartridge-js","78":"component---src-templates-content-page-js","79":"component---src-templates-product-js","80":"component---src-templates-skin-js"}[chunkId]||chunkId) + "-" + {"0":"f806513f90d339ae9078","1":"ec6ebe3a11ad92d00b85","2":"e7521c4f55ea32d49b86","3":"f361b9c145fd377e0bcb","4":"05b8f988c60dd2950366","5":"0b709ff2306310dd5a2c","6":"4c96cbe52a805e406db2","7":"fa0c43b267a42f9ad36e","8":"a5dc60bbdebcf7863c46","9":"5195186b1b3023fb8b9a","10":"e1ef7f70bdadc8d5cb6a","11":"bf426b62eb734bf0285d","12":"91c3435f9da6c68c91c4","13":"21936f4e6985a0df1e85","14":"7bcf0e3abb16fed22465","15":"9a6b7f38e6e87f63c1ba","16":"fb3804683ef74a598500","17":"4fdead45ca6a0a6df333","18":"7003522a91123bbc9e1c","19":"2d96f7ae5235a4451245","20":"27cefd0438c9665a7d4a","21":"c31aa2f0f3f860931054","22":"b6bb71790950f27358d2","23":"ea42f1476bae82b2b7ac","25":"6e217028977818f0011b","26":"07a1990904423a1415e0","29":"ba746eb9ba3908933821","30":"020d5d0defade2d2ef13","31":"15ba038e1f1aa4a046dd","32":"d6201522f04d8d62f17e","33":"8912df1ada1f630fb018","34":"57fcd7d1d60b45dbcb2b","35":"d6e3a81fc8af51a34289","36":"619dd76ed039cd2ee961","37":"115d7a4e4c42223bb93b","38":"2638dcc9ac5a21f1cb8c","39":"2363c80206ae0746db85","40":"790b25447fd09da5fff3","41":"020b5e70e0cd720d80a4","42":"90359472f4e03caf0890","43":"fdd80ac097369f2b472d","44":"81ac14bbd461631107e4","45":"9cacb054933fc7f92848","46":"858f4c8aea089ba99023","47":"949ac5d4232f8d20b9ac","48":"a030d3e00094fd30ca06","49":"cb7b85309653eca2fedb","50":"6eeca41ab1dc5942d8e5","51":"6efacdbb27f9826156c3","52":"d04631e0b34759cf9be0","53":"a3239563beaee4afa39f","54":"c5437f7cb6553e0a6ca3","55":"2e5ceae40d45419cfc9e","56":"e7cde5120d737434dcba","57":"7b62d2273efbf981428d","58":"170a640f49c091041dad","59":"104dc3925e0c29d9fb9f","60":"e190cef43b996463130c","61":"a6e9c0b5d5889548d6ce","62":"b13edd9eea22c2b211d1","63":"b9f8133aff937fb47c13","64":"7a2c03cfd188c21b55c6","65":"7c8f4e32f17653db851d","66":"d186bd8d204e7b32924d","67":"f1cdfb291f87487b77e7","68":"fda868fc090b8df1e04b","69":"6cf29b1ba7ddd6003fe1","70":"2d2ab40a8fe6c4d691a3","71":"ba95f7b5796c8f6eed0e","72":"d4c0f57c67f90182438d","73":"dbddef3cc40c13ce7802","74":"ec65ddaf12dfd11846d4","75":"9d173fcc9a4d7b968b2d","76":"f1bf197ba4a1369eae0a","77":"9790ef3eaf46500dc5dd","78":"0ac147c8d65f7b7b7d97","79":"b5bfe2c5e908a74fd790","80":"c84e0ae953362ddb7377","83":"5fc321cfe0af3377fe1e","84":"78f13039f44041500fa6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"framework","2":"2a42ed5b309b831996b49f08982ab7a4a24cae99","3":"0dd23f8cf9c6f4caba27e235780dc69f3665b42c","4":"e47fa9d5621b4e95aef8c07db5248df460519f91","5":"518cf1bce0dd04dc8c82e7e6b9851ff0d0b411dd","6":"1cfffe9f2e2abb3f8b3fd86840a4610f09ce1a32","7":"6944b5aa0dc5a4b0d337022ab4f44b8d0707a7bf","8":"ba2f737c89566affd54764cb6f4f4f24a7646d17","9":"d2918d33d883d725aee5f3ab6866aaa16243464b","10":"12552576a31d6d3d68f0b52e02739bbcfb8d4e73","11":"2365c79a59cabec54cd953fa05099f6130610e74","12":"2e6fd670878c7735087648f90002cdf1da0d4eaa","13":"7409aab60587d71ec7ac8ecdba1e280c541d0e28","14":"76223ff1009fe48bc60fbd7f75ff3c1d7a8c3748","15":"801a6084","16":"86889760b04c8d71da5a8b65d053f0fff4028907","17":"9f47a220e662f3d5ed876574306c3299ef29bc5f","18":"a2adb2a871cb4ae6843dd1f6e70c9ec95cc7d9c2","19":"styles","20":"5c968fe111ae3542c1f4673d3d051a3122a88ccc","21":"abf5ef3964d590ff84d589378b6f16e7ade0a4e3","22":"bcc0eb07330911ac31b0cf0fafa591ac97603503","23":"component---src-pages-account-subscriptions-flavours-js","29":"component---src-pages-404-js","30":"component---src-pages-account-email-verification-js","31":"component---src-pages-account-index-js","32":"component---src-pages-account-orders-js","33":"component---src-pages-account-rewards-js","34":"component---src-pages-account-savings-js","35":"component---src-pages-account-subscriptions-details-js","36":"component---src-pages-account-subscriptions-draft-js","37":"component---src-pages-account-subscriptions-index-js","38":"component---src-pages-bc-ban-js","39":"component---src-pages-bc-js","40":"component---src-pages-benefits-js","41":"component---src-pages-boost-plan-js","42":"component---src-pages-buy-online-epod-starter-bundle-js","43":"component---src-pages-buy-online-multipack-3-js","44":"component---src-pages-buy-online-multipack-5-js","45":"component---src-pages-buy-online-vuse-pods-js","46":"component---src-pages-buy-online-vype-epen-3-cartridges-js","47":"component---src-pages-buy-online-vype-epod-accessories-epod-charger-js","48":"component---src-pages-buy-online-vype-epod-accessories-js","49":"component---src-pages-buy-online-vype-epod-accessories-the-pouch-js","50":"component---src-pages-buy-online-vype-epod-skins-js","51":"component---src-pages-buy-online-vype-epod-vpro-cartridges-js","52":"component---src-pages-cart-js","53":"component---src-pages-challenge-js","54":"component---src-pages-checkout-js","55":"component---src-pages-clear-js","56":"component---src-pages-create-password-js","57":"component---src-pages-flagship-store-toronto-js","58":"component---src-pages-forgot-password-js","59":"component---src-pages-index-js","60":"component---src-pages-know-your-vuse-js","61":"component---src-pages-ontario-ban-js","62":"component---src-pages-ontario-js","63":"component---src-pages-order-confirmation-js","64":"component---src-pages-pos-rating-js","65":"component---src-pages-qc-js","66":"component---src-pages-queued-order-confirmation-js","67":"component---src-pages-referral-js","68":"component---src-pages-reset-password-js","69":"component---src-pages-soft-verify-js","70":"component---src-pages-subscribe-js","71":"component---src-pages-upgrade-to-epod-js","72":"component---src-pages-vape-stores-js","73":"component---src-pages-vuse-plus-vape-deals-js","74":"component---src-pages-vype-epod-starter-kit-js","75":"component---src-pages-vype-is-becoming-vuse-js","76":"component---src-templates-buy-js","77":"component---src-templates-cartridge-js","78":"component---src-templates-content-page-js","79":"component---src-templates-product-js","80":"component---src-templates-skin-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"cfd0b0e461c89ef89b2c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/ca/en/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
